import { apply, io } from 'fp-ts';
import * as applicative from './applicative.js';
import * as chain from './chain.js';
export * from 'fp-ts/IO';
export const run = (i) => i();
export const sequenceS = apply.sequenceS(io.Apply);
export const sequenceT = apply.sequenceT(io.Apply);
export const bindSequenceS = chain.bindSequenceS(io.Chain);
export const chainSequenceS = chain.chainSequenceS(io.Chain);
export const bindS = chain.bindS(io.Chain);
export const when = applicative.when(io.Applicative);
//# sourceMappingURL=io.js.map